import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import PublicHeader from './PublicHeader';
import PublicSidebar from './PublicSidebar';

interface HomeLayoutProps {
  children: React.ReactNode;
  /** Кнопка рейтинга l2oops в шапке — ставится только в маршруте главной. */
  showRatingBanner?: boolean;
}

const HomeLayout: React.FC<HomeLayoutProps> = ({ children, showRatingBanner }) => {
  const { user } = useAuth();
  const { i18n } = useTranslation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  // Sync i18n with user locale on mount and user change
  useEffect(() => {
    const targetLocale = user?.locale || localStorage.getItem('locale') || 'ru';
    if (i18n.language !== targetLocale) {
      i18n.changeLanguage(targetLocale);
    }
  }, [user?.locale, i18n]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100dvh',
        width: '100%',
        backgroundColor: '#000000',
      }}
    >
      {/* Header */}
      <PublicHeader onDrawerToggle={handleDrawerToggle} showRatingBanner={showRatingBanner} />

      {/* Mobile Sidebar */}
      <PublicSidebar mobileOpen={mobileOpen} onDrawerToggle={handleDrawerToggle} />

      {/* Main content - no padding, full width */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
        }}
      >
        {children}
      </Box>

      {/* No footer - HomePage has its own */}
    </Box>
  );
};

export default HomeLayout;
